import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BROKER } from "@/lib/constants";

export default function CtaBanner() {
  return (
    <section
      data-testid="cta-banner"
      className="py-20 sm:py-28 bg-pp-forest text-pp-bone relative overflow-hidden"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 text-center relative z-10">
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-tight">
          Ready to protect what matters most?
        </h2>
        <p className="mt-6 text-lg text-pp-bone/80 max-w-2xl mx-auto leading-relaxed">
          Get a personalized quote in about 5 minutes or book a free
          consultation directly with Darryl.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/quote">
            <Button
              data-testid="cta-banner-quote-btn"
              className="bg-pp-terracotta hover:bg-pp-terracotta-dark text-white rounded-full px-10 py-6 text-base"
            >
              Start my quote
            </Button>
          </Link>
          <a
            href={BROKER.calendarUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              data-testid="cta-banner-book-btn"
              variant="outline"
              className="border-pp-bone/40 text-pp-bone hover:bg-pp-bone hover:text-pp-forest-deep rounded-full px-10 py-6 text-base bg-transparent"
            >
              Book a consultation
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
